<template>
  <div class="module-space" style="overflow: hidden" v-if="data">
    <div class="container">
      <!-- 模块标题、副标题 -->
      <div class="good-sell-module" :style="{ 'text-align': data.align || 'center' }">
        <div class="good-sell-module__title title_font">
          {{ data.title }}
        </div>
        <div class="good-sell-module__subtitle secondary_title">
          {{ data.description }}
        </div>
      </div>
      <!-- 卡片内容 -->
      <div class="row p-1-7d5" style="justify-content: center">
        <template v-for="(item, index) in list">
          <div v-if="loading" :key="item + index" class="p-1-7d5 p-md-1-15" :class="getCol()">
            <v-good-sell-card
              theme="athena"
              :product-detail="getProductDetail(item.ids)"
              :card-config="item"
              :sell-config="data"
            >
            </v-good-sell-card>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import vGoodSellCard from '@/js/components/goodSell/Card.vue'
// import API from '@/js/API'
export default {
  props: {
    // 商品推售配置
    data: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      list: this.data?.items || [],
      products: [],
      loading: true,
    }
  },
  methods: {
    // 获取商品推售id
    getIds() {
      let arr = []
      if (this?.data?.items.length > 0) {
        this.data.items.map((item) => {
          if (item?.ids?.[0]) {
            arr.push(item.ids[0])
          }
        })
      }
      return arr
    },
    // 获取商品对应的信息
    getProductDetail(ids) {
      if (ids?.[0] && this.products.length > 0) {
        for (let i = 0; i < this.products.length; i++) {
          if (this?.products?.[i]?.ID == ids[0]) {
            return this.products[i]
          }
        }
      }
      return {}
    },
    // 排列方式
    getCol() {
      let pc = 'col-md-4'
      let mb = 'col-12'
      if (this?.data?.mb_row_amount == 2) {
        mb = 'col-6'
      }
      if (this?.data?.row_amount == 4) {
        pc = 'col-md-3'
      } else if (this?.data?.row_amount == 5) {
        pc = 'col-md-2_4'
      }
      return [pc, mb]
    },
  },
  async mounted() {
    // 获取数据
    if (this.getIds().length) {
      try {
        // this.loading = false
        let params = {
          id: this.getIds().join(),
        }
        let res = await this.$axios.get(API.products, { params })
        if (res?.data?.data) {
          this.products = res.data.data
        }
        this.loading = true
      } catch (error) {
        this.loading = true
        if (error?.response?.data?.message) {
          this.$message.error(error.response.data.message)
        }
      }
    }
  },
  components: {
    vGoodSellCard,
  },
}
</script>

<style scoped lang='scss'>
.good-sell-module {
  color: #222a40;
  &__title {
    font-weight: bold;
    font-size: 30px;
    line-height: 35px;
    margin-bottom: 20px;
  }
  &__subtitle {
    font-size: 20px;
    line-height: 23px;
    margin-bottom: 40px;
  }
}
@media screen and (min-width: 767px) {
  .col-md-2_4 {
    flex: 0 0 20%;
    max-width: 20%;
  }
}

@media screen and (max-width: 767px) {
  .good-sell-module {
    &__title {
      font-size: 16px;
      line-height: 19px;
      margin-bottom: 10px;
    }
    &__subtitle {
      font-size: 14px;
      line-height: 17px;
      margin-bottom: 20px;
    }
  }
}
</style>